module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('content-title', {
    attrs: {
      "title": "资料下载"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('div', {
    staticClass: "output-content-1"
  }, [_c('div', {
    staticClass: "checkbox-content"
  }, [_c('span', [_vm._v("文档下载")]), _vm._v(" "), _c('a', {
    staticClass: "checkbox-one",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.down3 = _vm.down2;
        _vm.down2 = !_vm.down2;
      }
    }
  }, [(_vm.down2) ? _c('img', {
    attrs: {
      "src": require("assets/checked-2.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.down2) ? _c('img', {
    attrs: {
      "src": require("assets/unchecked-2.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n            简洁版VPR介绍资料\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "checkbox-one",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.down2 = _vm.down3;
        _vm.down3 = !_vm.down3
      }
    }
  }, [(_vm.down3) ? _c('img', {
    attrs: {
      "src": require("assets/checked-2.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.down3) ? _c('img', {
    attrs: {
      "src": require("assets/unchecked-2.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox-label"
  }, [_vm._v("\n            详细版VPR介绍资料\n          ")])]), _vm._v(" "), (_vm.login === 1) ? _c('a', {
    staticClass: "output-btn btm-btn",
    attrs: {
      "href": _vm.down2 ? '/static/问题介绍简洁版.pdf' : '/static/问题介绍详细版.pdf',
      "download": _vm.down2 ? '问题介绍简洁版.pdf' : '问题介绍详细版.pdf'
    }
  }, [_vm._v("下载文档")]) : _c('a', {
    staticClass: "output-btn btm-btn",
    on: {
      "click": _vm.goLgin
    }
  }, [_vm._v("下载文档")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20f65c7c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/down.vue
// module id = 962
// module chunks = 1